export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";